export default __webpack_public_path__ + "static/media/onboardingMobile.599a5912.png";